<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-tag">
      New Label
    </page-title>
    <v-form @submit.prevent="submit"
            :disabled="form.busy"
            autocomplete="off">
      <v-card>

        <v-card-text>
          <v-text-field v-model="form.name"
                        label="Name"
                        placeholder="Should be unique"
                        autocomplete="new-name"
                        :error-messages="form.errors.get('name')">
          </v-text-field>

          <v-autocomplete v-model="form.groups"
                          label="Restrict access to these groups"
                          :items="groups"
                          item-text="name"
                          item-value="id"
                          placeholder="Select or search"
                          hint="If you don't select any groups, then every group will have access to this label."
                          persistent-hint
                          chips
                          deletable-chips
                          multiple>
          </v-autocomplete>


          <v-autocomplete v-model="form.presentations"
                          label="Apply to these presentations"
                          :items="presentations"
                          item-text="name"
                          item-value="id"
                          placeholder="Select or search"
                          chips
                          deletable-chips
                          multiple>
          </v-autocomplete>


          <v-autocomplete v-model="form.locale"
                          label="Language"
                          :items="locales"
                          item-value="id"
                          item-text="name"
                          placeholder="Optional"
                          clearable>
          </v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Create
          </v-btn>
          <v-btn :to="{name: 'admin.labels.index'}"
                 text>
            Cancel
          </v-btn>
        </v-card-actions>


      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  metaInfo() {
    this.$store.commit('setTitle', 'Create Label')
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      form: new Form({
        name: '',
        status: 'Active',
        locale: '',
        presentations: [],
        groups: [],

      }),
      loading: false,
      busy: false,
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'presentations',
      'team',
      'labels',
      'locales',
    ]),
    isLoading() {
      return this.loading;
    }
  },
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.post(`/api/labels`)
        .then(response => {
          this.$toast.success('Label created.');
          this.$router.push({name: 'admin.labels.index'});
          this.$store.dispatch('fetchLabels');
        })
        .catch(err => {
          this.$toast.error('There was a problem.');
        })

    }
  },
}
</script>
